const homeResources = {
    title: 'Employee Wellness Programs',
};
export default homeResources;